import type { QuestionHotTagItemDTO } from '@patsnap/ls360_sdk_feature'
import { HOT_TAG_SCENE_TYPE, IHotTagRes } from '../../types'
import { IHttp, IHttpWrap } from '../http/types'
import { BaseApi } from './baseApi'

export class TagApi extends BaseApi {
  constructor(http: IHttp, baseUrl: string) {
    super(http, baseUrl)
  }

  async getHotTags(data: { scene_type: HOT_TAG_SCENE_TYPE }): Promise<IHttpWrap<IHotTagRes>> {
    return this.http({
      method: 'POST',
      data: {
        scene_type: [data.scene_type],
      },
      url: this.getUrl(`discoveryls_common/1.0/hottag/search`),
      cache: true,
    })
  }

  async getLS360HotTags(data: { scene_type: string[] }): Promise<
    IHttpWrap<{
      hot_tag_map: {
        [key in string]: QuestionHotTagItemDTO[]
      }
    }>
  > {
    return this.http({
      method: 'POST',
      data,
      url: this.getUrl('discoveryls_common/1.0/hottag/search'),
      cache: true,
    })
  }
}
